import React, {useEffect, useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {BASE_URL} from '../config';
function WarehouseList() {
    const [warehouses, setWarehouses] = useState([]);
    const [editWarehouse, setEditWarehouse] = useState(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const [newWarehouseName, setNewWarehouseName] = useState('');

    // Define fetchWarehouses function
    const fetchWarehouses = async () => {
        const response = await fetch(`${BASE_URL}/api/warehouses`);
        const data = await response.json();
        setWarehouses(data);
    };

    // Fetch warehouses on component mount
    useEffect(() => {
        fetchWarehouses();
    }, []);

    const openEditModal = (warehouse) => setEditWarehouse(warehouse);

    const editWarehouseName = async (id, newName) => {
        const response = await fetch(`${BASE_URL}/api/warehouses/${id}/edit`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ name: newName }),
        });

        if (response.ok) {
            setWarehouses(prev => prev.map(
                whs => whs.id === id ? { ...whs, name: newName } : whs
            ));
            setEditWarehouse(null);
        } else {
            alert('Error editing warehouse');
        }
    };

    const deleteWarehouse = async (id) => {
        const response = await fetch(`${BASE_URL}/api/warehouses/${id}/delete`, {method: 'POST'});
        if (response.ok) {
            setWarehouses(prev => prev.filter(warehouse => warehouse.id !== id));
        } else {
            alert('Error deleting warehouse');
        }
    };

    const addNewWarehouse = async () => {
        const response = await fetch(`${BASE_URL}/api/warehouses/add`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ name: newWarehouseName }),
        });

        if (response.ok) {
            fetchWarehouses();  // Refresh the warehouse list
            setNewWarehouseName('');
            setShowAddModal(false);
        } else {
            alert('Error adding new warehouse');
        }
    };

    return (
        <div>
            <h2 className="mb-4">Lista magazynów</h2>
            <table className="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>Nazwa magazynu</th>
                        <th>Liczba produktów</th>
                        <th>Akcje</th>
                    </tr>
                </thead>
                <tbody>
                    {warehouses.map(warehouse => (
                        <tr key={warehouse.id}>
                            <td>{warehouse.name}</td>
                            <td>{warehouse.produkt_count}</td>
                            <td>
                                <Button variant="outline-primary" size="sm" onClick={() => openEditModal(warehouse)}>
                                    Edytuj
                                </Button>
                                <Button variant="outline-danger" size="sm" onClick={() => deleteWarehouse(warehouse.id)}>
                                    Usuń
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <Button variant="success" onClick={() => setShowAddModal(true)}>Dodaj nowy magazyn</Button>
            
            {editWarehouse && (
                <Modal show={Boolean(editWarehouse)} onHide={() => setEditWarehouse(null)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Edytuj nazwę magazynu</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={(e) => {
                            e.preventDefault();
                            const newName = e.target.elements.newName.value;
                            editWarehouseName(editWarehouse.id, newName);
                        }}>
                            <div className="mb-3">
                                <label htmlFor="newName" className="form-label">Nowa nazwa</label>
                                <input type="text" className="form-control" id="newName" defaultValue={editWarehouse.name} required />
                            </div>
                            <Button variant="primary" type="submit">Zapisz zmiany</Button>
                        </form>
                    </Modal.Body>
                </Modal>
            )}

            <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Dodaj nowy magazyn</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        addNewWarehouse();
                    }}>
                        <div className="mb-3">
                            <label htmlFor="newWarehouseName" className="form-label">Nazwa magazynu</label>
                            <input
                                type="text"
                                className="form-control"
                                id="newWarehouseName"
                                value={newWarehouseName}
                                onChange={(e) => setNewWarehouseName(e.target.value)}
                                required
                            />
                        </div>
                        <Button variant="primary" type="submit">Dodaj</Button>
                    </form>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default WarehouseList;
